import { render } from "./ForgotPass.vue?vue&type=template&id=3ad05177&scoped=true"
import script from "./ForgotPass.vue?vue&type=script&lang=js"
export * from "./ForgotPass.vue?vue&type=script&lang=js"

import "./ForgotPass.vue?vue&type=style&index=0&id=3ad05177&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad05177"]])

export default __exports__